module.exports = __webpack_public_path__ + "c_static/img/8查看问大家.41a09bd.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/img/8查看问大家.jpg
// module id = zpTW
// module chunks = 33